import React from 'react';
import { useTranslation } from 'react-i18next';
import { Page, Text, Card } from '@shopify/polaris';

const Info = () => {
    const { t } = useTranslation();

    const descriptionParagraphs = t('info.description').split('\n\n');
    return (
        <Page>
            <Card>
                <div style={{ paddingLeft: "20px", paddingRight: "20px" }}>
                    <div style={{ marginTop: "20px" }}>
                        <Text variant="headingMd" as="h5" fontWeight="bold">
                            {t('info.title')}
                        </Text><br />
                        <div style={{ marginTop: "5px" }}>
                            {descriptionParagraphs.map((paragraph, index) => (
                                <Text as="p" key={index}>
                                    {paragraph}
                                </Text>
                            ))}
                        </div>
                        <div style={{ marginTop: "15px", textAlign: "left" }}>
                            <Text as="p" variant="bodySm" color="subdued">
                                {t('info.discover')}{' '}
                                <a
                                    href="https://crewcart.com"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    style={{ color: 'inherit', textDecoration: 'underline' }}
                                >
                                    crewcart.com
                                </a>
                            </Text>
                        </div>
                    </div>
                </div>
            </Card>
        </Page>
    );
};

export default Info;
